import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCountry } from "../Context/CountryContext";

const GeoRedirect = () => {
  const navigate = useNavigate();
  const { country, loading } = useCountry();

  useEffect(() => {
    if (!loading && country?.route) {
      navigate(country.route, { replace: true });
    }
  }, [country, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-gray-700">
      <div className="text-center px-6">
        <div className="mx-auto h-10 w-10 rounded-full border-4 border-blue-100 border-t-[#1A4699] animate-spin" />
        <p className="mt-4 text-sm">Loading the right Konn3ct experience...</p>
      </div>
    </div>
  );
};

export default GeoRedirect;
